import React from 'react'
import { Form, Col } from '_zari/core'
import { Field } from 'formik'
import * as FamiliaService from 'services/familia.service'

const FamiliaFormGroup = ({ categoriaId, iError, iTouched, fIsSubmitting, values, setValues }) => {
  const [familias, setFamilias] = React.useState([])

  React.useEffect(() => {
    if (categoriaId) {
      FamiliaService.getFamilias_Select(categoriaId).then(({ data }) => {
        setFamilias(data)
        setValues(prev => ({ ...prev, _idFamilia: '', _idSubFamilia: '' }))
      })
    } else {
      setFamilias([])
      setValues(prev => ({ ...prev, _idFamilia: '', _idSubFamilia: '' }))
    }
  }, [categoriaId, setValues])

  return (
    <Form.Group>
      <Form.Label text='FAMILIA' htmlFor='select-familia' md={3} alignRightAt='md' />
      <Col md={9}>
        <Form.InputGroup>
          <Field name='_idFamilia'>
            {({ field }) => (
              <Form.Select
                {...field}
                disabled={!categoriaId || fIsSubmitting}
                isInvalid={iTouched && iError}
                onChange={e => {
                  field.onChange(e)
                  setValues(prev => ({
                    ...prev,
                    _idFamilia: e.target.value,
                    _idSubFamilia: ''
                  }))
                }}
                id='select-familia'
              >
                <option value=''>Seleccionar</option>
                {familias.map(f => (
                  <option key={f._id} value={f._id}>
                    {f.nombre}
                  </option>
                ))}
              </Form.Select>
            )}
          </Field>
        </Form.InputGroup>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default FamiliaFormGroup
